/* eslint @typescript-eslint/no-explicit-any: 0 */
export default () => {
    let resolve;
    let reject;
    const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
    });
    return Object.assign(promise, {
        resolve: resolve,
        reject: reject,
    });
};
//# sourceMappingURL=defer.mjs.map